import React, { useState } from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper, 
  TextField, 
  Button, 
  Divider, 
  Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PayPalButtonStandard from '../components/PayPalButtonStandard';
import { useAuth } from '../contexts/AuthContext';

const PayPalDemo = () => {
  const [amount, setAmount] = useState('10.00');
  const [currency, setCurrency] = useState('USD');
  const [paymentResult, setPaymentResult] = useState(null);
  const [error, setError] = useState('');
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  
  // 检查用户是否已登录
  React.useEffect(() => {
    if (!currentUser) {
      navigate('/login', { state: { from: { pathname: '/paypal-demo' } } });
    }
  }, [currentUser, navigate]);
  
  // 处理金额变化
  const handleAmountChange = (e) => {
    const value = e.target.value;
    // 确保只有有效的数字格式
    if (/^\d*\.?\d{0,2}$/.test(value) || value === '') {
      setAmount(value);
    }
  };
  
  // 支付成功处理
  const handlePaymentSuccess = (data) => {
    console.log('支付成功:', data);
    setPaymentResult(data);
    setError('');
  };
  
  // 支付错误处理
  const handlePaymentError = (err) => {
    console.error('支付错误:', err);
    setError(`支付过程中发生错误: ${err.message || '未知错误'}`);
    setPaymentResult(null);
  };
  
  if (!currentUser) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Alert severity="info">请先登录后再尝试PayPal支付</Alert>
      </Container>
    );
  }
  
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 6 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        PayPal标准集成演示
      </Typography>
      
      <Paper elevation={3} sx={{ p: 4, mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          设置支付金额
        </Typography>
        
        <Box sx={{ mb: 3 }}>
          <TextField
            label="金额"
            variant="outlined"
            value={amount}
            onChange={handleAmountChange}
            fullWidth
            margin="normal"
            type="text"
            placeholder="10.00"
            inputProps={{ inputMode: 'decimal' }}
            helperText="请输入有效的金额 (例如: 10.00)"
          />
          
          <TextField
            label="货币"
            variant="outlined"
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            fullWidth
            margin="normal"
            select
            SelectProps={{ native: true }}
          >
            <option value="USD">美元 (USD)</option>
            <option value="EUR">欧元 (EUR)</option>
            <option value="GBP">英镑 (GBP)</option>
            <option value="AUD">澳元 (AUD)</option>
            <option value="CAD">加元 (CAD)</option>
          </TextField>
        </Box>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h6" gutterBottom>
          使用PayPal付款
        </Typography>
        
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        {paymentResult && (
          <Alert severity="success" sx={{ mb: 2 }}>
            支付成功! 订单ID: {paymentResult.orderID}
          </Alert>
        )}
        
        <PayPalButtonStandard
          amount={parseFloat(amount) || 10.00}
          currency={currency}
          onSuccess={handlePaymentSuccess}
          onError={handlePaymentError}
        />
        
        {paymentResult && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6">支付详情:</Typography>
            <Paper variant="outlined" sx={{ p: 2, mt: 1, backgroundColor: '#f5f5f5' }}>
              <pre style={{ overflow: 'auto', margin: 0 }}>
                {JSON.stringify(paymentResult, null, 2)}
              </pre>
            </Paper>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default PayPalDemo;